import React from 'react';
import styled from 'styled-components';
import Typography from '../Typography';
import { theme } from '../../theme';

const EventTypeTab = ({ category, isActive, onClick, icon, iconSize = '24px' }) => {
  return (
    <TabWrapper $isActive={isActive} onClick={onClick}>
      <StyledIcon $size={iconSize}>{icon}</StyledIcon>
      <Typography as="p" $variant="body-3-semibold" $variantTablet="caption-semibold" $variantMobile="caption-semibold" color={isActive ? theme.colors.brandMain : theme.colors.defaultSubtle}>{category}</Typography>
    </TabWrapper>
  );
};

export default EventTypeTab;


const TabWrapper = styled.div`
  align-items: center;
  border-bottom: ${({ theme }) => theme.sizing.xxs} solid ${({ $isActive, theme }) => ($isActive ? theme.colors.brandMain : theme.fill.defaultSubtle)};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: ${({ theme }) => theme.sizing.xs};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    border-bottom: 2px solid ${({ $isActive, theme }) => ($isActive ? theme.colors.brandMain : theme.fill.defaultSubtle)};
  }
`;

const StyledIcon = styled.span`
  height: ${({ $size }) => $size};
  width: ${({ $size }) => $size};

  svg {
    height: ${({ $size }) => $size};
    width: ${({ $size }) => $size};
  }
`;
